import React, { useContext, useEffect, useRef, useState } from "react";
import {
  MyBookPanditCategoryAPI,
  MyBookPanditPujaListAPI,
} from "../../ApiServices/BookPanditAPI/BookPanditAPI";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Tooltip } from "@mui/material";
import "./BookPandit.css";
import placeholderImg from "../../assets/images/new/fav-removebg-preview.png";
import Batuk from "../../assets/images/new/fav-removebg-preview.png";
import {
  LoaderContext,
} from "../../AuthContext/AuthContext";
import Select from "react-select";
import Breadcrumbs from "../../Components/Breadcrumb";
import { customSelectStyles } from "../../middlewares/Utils";
import { t } from "i18next";

const BookPandit = () => {
  const [myBookPanditData, setMyBookPanditData] = useState([]);
  const [pujaListData, setPujaListData] = useState([]);
  const [catID, setCatID] = useState(null);
  const [search, setSearch] = useState("");
  const [selectedCatId, setSelectedCatId] = useState(null);
  const { setLoader, loader, pujaStatus, setPujaStatus, selectedLanguageID, fetchedLocation } =
    useContext(LoaderContext);
  const user_id = localStorage.getItem("userID");
  const location = useLocation();
  const navigate = useNavigate();
  const [status, setStatus] = useState(
    pujaStatus === null ? false : pujaStatus
  );
  const [myBookPanditDataMobile, setMyBookPanditDataMobile] = useState([]);
  const [isMobile, setIsMobile] = useState(false);
  const categoryListRef = useRef(null);
  const productListRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);



  }, []);





  useEffect(() => {

    if (catID !== null && catID !== undefined && catID !== "") {
      const ID = status ? 1 : 2;
      if (!isMobile) {
        GetMyBookPanditCategoryData();

      }
      GetMyBookPanditPujaListData(ID);
    }
  }, [catID, pujaStatus, status, selectedLanguageID]);


  useEffect(() => {
    if (
      location?.state?.selectedCat !== null &&
      location?.state?.selectedCat !== undefined
    ) {
      setCatID(location?.state?.selectedCat);
      setSelectedCatId(location?.state?.selectedCat);
    }


  }, [location]);

  useEffect(() => {

    if (location?.pathname === "/services/online-puja/pitru-paksha-puja") {
      setPujaStatus(true)
      setStatus(true)
      setSelectedCatId(43)
      setCatID(43)
      sessionStorage.setItem("selectedCatId", 43);
    } else if (location?.pathname === "/services/online-puja/brahmin-bhoj") {
      setPujaStatus(true)
      setStatus(true)
      setSelectedCatId(44)
      setCatID(44)
      sessionStorage.setItem("selectedCatId", 44);
    } else {
      GetMyBookPanditCategoryData();
    }
  }, [])

  const GetMyBookPanditCategoryData = async () => {
    setLoader(true);
    const response = await MyBookPanditCategoryAPI(selectedLanguageID);

    try {
      if (
        response.ResponseMessage === "list" &&
        response.ResponseCode === "0"
      ) {

        const Data = response.DATA;
        let filteredData = [];
        if (status) {
          filteredData = Data?.filter(
            (val) => val?.OnlinePujaCount > 0
          );
          setMyBookPanditData(filteredData);
        } else {
          filteredData = Data?.filter(
            (val) => val?.OfflinePujaCount > 0
          );
          setMyBookPanditData(filteredData);
        }

        const options = filteredData
          .filter((item) => item.PUJACAT_ID && item.PUJACAT_NAME)
          .map((item) => ({
            value: item.PUJACAT_ID,
            label: item.PUJACAT_NAME,
          }));

        setMyBookPanditDataMobile(options);

        const storedCatId = sessionStorage.getItem("selectedCatId");
        const isExist = options?.some(
          (option) => Number(option?.value) === Number(storedCatId)
        );

        if (isExist) {
          if (
            storedCatId !== null &&
            storedCatId !== undefined &&
            Number(storedCatId) > 0
          ) {
            setCatID(Number(storedCatId));
            setSelectedCatId(Number(storedCatId));
          } else {
            setCatID(filteredData[0]?.PUJACAT_ID);
            setSelectedCatId(filteredData[0]?.PUJACAT_ID);
          }
        } else {
          setCatID(filteredData[0]?.PUJACAT_ID);
          setSelectedCatId(filteredData[0]?.PUJACAT_ID);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const GetMyBookPanditPujaListData = async (requestedFilter) => {
    setLoader(true);
    try {
      const response = await MyBookPanditPujaListAPI(user_id, catID, {
        START: 1,
        END: 1000,
        WORD: "None",
        LATITUDE: fetchedLocation.lat,
        LONGITUDE: fetchedLocation.lon,
      }, selectedLanguageID);

      if (response) {
        setLoader(false);
        const filteredData = response?.DATA?.filter(
          (value) =>
            value.PoojaTypeID === requestedFilter ||
            value.PoojaTypeID === 3
        );
        setPujaListData(filteredData);
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };

  const viewDetail = (product) => {
    const newSlug = product?.PujaSlug;
    if (catID) {
      sessionStorage.setItem("selectedCatId", catID);
    }
    navigate(`/services/book-puja/${newSlug}`, {
      state: { product: product, PujaStatus: status ? 1 : 2 },
    });
  };

  const ProductCard = ({ product }) => (
    <div
      className="col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-4 "
      style={{ maxWidth: isMobile ? "100%" : "320px" }}
      onClick={() => viewDetail(product)}
    >
      <div
        className="card shadow-sm  rounded-3 h-100 border bolder-dark"
        style={{ cursor: "pointer", overflow: "hidden" }}
        onClick={() => viewDetail(product)}
      >
        {/* Image Section */}
        <div className="position-relative">
          <img
            src={product.PUJA_IMAGE || placeholderImg}
            alt={product.PUJA_NAME}
            className="card-img-top"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = placeholderImg;
            }}
            style={{
              height: "150px",
              objectFit: "cover",
              borderTopLeftRadius: "12px",
              borderTopRightRadius: "12px",
            }}
          />


        </div>

        {/* Card Body */}
        <div className="card-body p-2 d-flex flex-column">
          <h6
            className="card-title fw-bold mb-1"
            style={{ color: "#8f3246", fontSize: "16px" }}
          >
            {product.PUJA_NAME}
          </h6>

          <p className="text-muted mb-0" style={{ fontSize: "14px" }}>
            {product.PUJA_TAGLINE || "A powerful ritual description..."}
          </p>



          {/* Price & Button */}
          <div className="mt-auto">
            <span
              className="fw-bold"
              style={{ fontSize: "16px", color: "#000" }}
            >
              ₹
              {product.OnlinePujaPrice
                ? Math.round(product.OnlinePujaPrice - (product.DiscountAmount || 0))
                : Math.round(product.OfflinePujaPrice - (product.DiscountAmount || 0))}
            </span>
            <button
              className="btn w-100 mt-2"
              style={{
                backgroundColor: "#8f3246",
                color: "#fff",
                borderRadius: "8px",
                textTransform: "none",
              }}
            >
              <span className="blink-text" onClick={() => viewDetail(product)}>Book Puja Now</span>
            </button>

          </div>
        </div>
      </div>
    </div>


  );

  const handleCatChange = (category) => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    if (categoryListRef.current) {
      productListRef.current.scrollTo({ top: 0, behavior: "smooth" });
    }
    setCatID(category.PUJACAT_ID);
    setSelectedCatId(category.PUJACAT_ID);
    sessionStorage.setItem("selectedCatId", category?.PUJACAT_ID);
  };

  const HandlePujaTypeChange = (value) => {
    if (value === "offline") {
      setPujaStatus(false);
      setStatus(false);
    } else {
      setPujaStatus(true);
      setStatus(true);
    }

  };



  return (
    <>
      <section className="page-header" style={{ height: isMobile && "225px" }}>
        <div className="page-header__bg"></div>
        <div className="container">
          <h2 className="page-header__title bw-split-in-left">{t("Book Puja")}</h2>
        </div>
      </section>

      <div className="main py-4">
        <div className="container px-3 px-md-4">
          <div className="row gx-4 gy-4" >
            <div className="breadcrumbMobile" style={{ padding: "8px", marginTop: '0px' }}>
              <Breadcrumbs />
            </div>

            {!isMobile ? (
              <div className="left col-md-3 col-sm-4" style={{ marginTop: '0px' }}>
                {/* <div className=" align-items-center gap-4 ">
                  <h4
                    className="custom-list-item clearfix"
                    style={{
                      fontFamily: "Bricolage Grotesque",
                      fontSize: "20px",
                      borderBottom: "1px solid lightgray",
                      textTransform: "none",
                      padding: "12px",
                    }}
                  >
                    {t("Puja Type")}
                  </h4>

                  <label className="d-flex align-items-center gap-1 px-3">
                    <input
                      type="checkbox"
                      checked={!pujaStatus}
                      onChange={() => HandlePujaTypeChange("offline")}
                    />
                    {t("Offline Puja")}
                  </label>

                  <label className="d-flex align-items-center gap-1 px-3">
                    <input
                      type="checkbox"
                      checked={pujaStatus}
                      onChange={() => HandlePujaTypeChange("online")}
                    />
                    {t("Online Puja")}
                  </label>
                </div> */}
                <div>
                  <h4
                    className="custom-list-item clearfix"
                    style={{
                      fontFamily: "Bricolage Grotesque",
                      fontSize: "20px",
                      borderBottom: "1px solid lightgray",
                      textTransform: "none",
                      padding: "12px",
                    }}
                  >
                    {t("Puja Category")}
                  </h4>

                  {/* Scrollable wrapper */}
                  <div
                    ref={categoryListRef}

                    className="scrollable-category"
                    style={{
                      maxHeight:
                        pujaListData?.length <= 6
                          ? "25em"
                          : pujaListData?.length <= 10
                            ? "50em"
                            : pujaListData?.length <= 25
                              ? "90em"
                              : pujaListData?.length <= 45
                                ? "120em"
                                : "150em",
                      overflowY: "auto",
                      paddingRight: "5px",
                    }}



                  >
                    <ul className="margin-bottom-25 sidebar-menu list-unstyled">
                      {myBookPanditData?.length > 0 ? (
                        myBookPanditData.map((category, index) => (
                          <li className="list-group-item clearfix" key={index}>
                            <Link
                              to="#"
                              onClick={() => handleCatChange(category)}
                              className={`d-flex align-items-center ${selectedCatId === category.PUJACAT_ID ? "active" : ""}`}
                              style={{ textWrap: "nowrap" }}
                            >
                              <i className="fa fa-angle-right me-2"></i>
                              {category.PUJACAT_NAME?.length > 30 ? (
                                <Tooltip title={category.PUJACAT_NAME}>
                                  {`${category.PUJACAT_NAME.substring(0, 19)}...`}
                                </Tooltip>
                              ) : (
                                category.PUJACAT_NAME
                              )}
                            </Link>
                          </li>
                        ))
                      ) : (
                        <li className="list-group-item">No categories available</li>
                      )}
                    </ul>
                  </div>
                </div>
              </div>
            ) : (
              <Select
                styles={customSelectStyles}
                options={myBookPanditDataMobile}
                placeholder="Select Category"
                value={myBookPanditDataMobile.find(
                  (option) => option.value === catID
                )}
                onChange={(selectedOption) => {
                  setCatID(selectedOption.value);
                  setSelectedCatId(selectedOption.value);
                }}
              />
            )}

            {/* Product List */}
            <div className="right col-md-9 col-sm-8 " style={{ marginTop: '0px' }}>
              {pujaListData?.length !== 0 ? (
                <div
                  className="row w-100"
                  style={{ justifyContent: "flex-start", marginTop: '0px' }}
                  ref={productListRef}
                >
                  {pujaListData
                    ?.filter(
                      (product) =>
                        search === "" ||
                        product.PUJA_NAME.toLowerCase().includes(search.toLowerCase())
                    )
                    .map((product) => (
                      <ProductCard
                        key={product.PUJA_ID}
                        product={product}
                        viewDetail={viewDetail}
                        placeholderImg={placeholderImg}
                      />
                    ))}
                </div>
              ) : !loader ? (
                <div className="d-flex flex-column align-items-center justify-content-center vh-90 text-center mt-4">
                  <img
                    src={Batuk}
                    alt="Empty Cart"
                    className="img-fluid mb-3"
                    style={{ maxWidth: "200px" }}
                  />
                  <h5 className="fw-bold text-center">
                    No services available for this category
                  </h5>
                  <p className="text-muted">Please explore our other categories.</p>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>

    </>
  );
};

export default BookPandit;
